import React, { createContext, useMemo } from 'react';

type Permissions = {
  canEdit: boolean;
  canExport: boolean;
};

type Props = {
  userRoleId: number;
  children: React.ReactNode;
};

export const PermissionsContext = createContext<Permissions>({
  canEdit: true,
  canExport: true,
});

export const PermissionsProvider: React.FC<Props> = ({ userRoleId, children }) => {
  const permissions = useMemo<Permissions>(() => ({
    canEdit: userRoleId !== 9,
    canExport: true,
  }), [userRoleId]);

  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
};
